export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--bw-border)] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <h4 className="font-serif-display text-3xl leading-none">
            book<span className="text-[var(--bw-accent)]">wrck</span>
          </h4>
          <p className="mt-3 text-sm text-[var(--bw-secondary)] max-w-xs leading-relaxed">
            Whole books, rendered in five pages. Read what matters — skip the
            filler.
          </p>
        </div>
        <div className="text-sm">
          <p className="font-mono-plex text-xs uppercase tracking-widest text-[var(--bw-secondary)] mb-3">
            Explore
          </p>
          <ul className="space-y-2">
            <li>Catalog</li>
            <li>New releases</li>
            <li>Bestsellers</li>
          </ul>
        </div>
        <div className="text-sm">
          <p className="font-mono-plex text-xs uppercase tracking-widest text-[var(--bw-secondary)] mb-3">
            Company
          </p>
          <ul className="space-y-2">
            <li>Made in a small studio</li>
            <li>hello@bookwrck.co</li>
            <li>© {new Date().getFullYear()} BookWrck</li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
